var map = {
	"./company-report/company-report.html": "views/pages/modules/orders/plugins/company-report/company-report.html",
	"./default-screening/default-screening.html": "views/pages/modules/orders/plugins/default-screening/default-screening.html",
	"./doc-subscore-forecast-pdf/doc-subscore-forecast-pdf.html": "views/pages/modules/orders/plugins/doc-subscore-forecast-pdf/doc-subscore-forecast-pdf.html",
	"./dry-bulk-vetting/dry-bulk-vetting.html": "views/pages/modules/orders/plugins/dry-bulk-vetting/dry-bulk-vetting.html",
	"./pre-arrival-check/pre-arrival-check.html": "views/pages/modules/orders/plugins/pre-arrival-check/pre-arrival-check.html",
	"./processing/processing.html": "views/pages/modules/orders/plugins/processing/processing.html",
	"./tanker-vetting-with-sire-banner/tanker-vetting-with-sire-banner.html": "views/pages/modules/orders/plugins/tanker-vetting-with-sire-banner/tanker-vetting-with-sire-banner.html",
	"./trade-check/trade-check.html": "views/pages/modules/orders/plugins/trade-check/trade-check.html",
	"./vessel-comparison-pdf/vessel-comparison-pdf.html": "views/pages/modules/orders/plugins/vessel-comparison-pdf/vessel-comparison-pdf.html",
	"./vessel-esg-comparison-report/vessel-esg-comparison-report.html": "views/pages/modules/orders/plugins/vessel-esg-comparison-report/vessel-esg-comparison-report.html",
	"./vessel-health-check/vessel-health-check.html": "views/pages/modules/orders/plugins/vessel-health-check/vessel-health-check.html",
	"./vessel-rightship-inspection-report/selected-vessel-inspections.html": "views/pages/modules/orders/plugins/vessel-rightship-inspection-report/selected-vessel-inspections.html",
	"./vessel-rightship-inspection-report/vessel-rightship-inspection-report.html": "views/pages/modules/orders/plugins/vessel-rightship-inspection-report/vessel-rightship-inspection-report.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75890;